export default class navigationDropdowns {

  constructor(els) {
    this.$menus = [...els];
    this.triggers = document.querySelectorAll('[aria-controls]');
    this.menus = this.initMenus();
  }

  initMenus() {
    return this.$menus.map(menu => {
      const trigger = [...this.triggers].find(t => t.getAttribute('aria-controls') === menu.id);
      return new navigationDropdown(menu, trigger, this);
    });
  }

  closeOtherMenus(activeMenu) {
    this.menus.forEach(menu => {
      if (menu !== activeMenu && menu.active) {
        menu.toggle();
      }
    });
  }

}



export class navigationDropdown {

  constructor(menu, trigger, manager) {
    this.$menu = menu;
    this.manager = manager;
    this.active = !this.$menu.hasAttribute("hidden");
    this.tl = this.getTimeline();

    this.$trigger = trigger;
    if (!this.$trigger) {
      console.error("No matching trigger found for dropdown menu:", this.$menu);
      return;
    }

    this.$trigger.addEventListener("click", (e) => {
      this.toggle();
      this.manager.closeOtherMenus(this);
    });

    // Now that we've initialized the timeline, if the menu is not hidden by default, reverse the timeline to its initial state
    if (!this.$menu.hasAttribute("hidden")) {
      this.tl.reverse();
    }

    // Bind the outside click handler to the instance.
    this.outsideClickHandler = this.outsideClickHandler.bind(this);
  }



  toggle() {
    this.active = !this.active;

    // Play or reverse the timeline based on the active state
    if (this.active) {
      this.tl.play();

      // Add the outside click event listener when the dropdown is opened.
      document.addEventListener('click', this.outsideClickHandler);
    } else {
      this.tl.reverse();

      // Remove the outside click event listener when the dropdown is closed.
      document.removeEventListener('click', this.outsideClickHandler);
    }

    this.$trigger.setAttribute("aria-expanded", this.active.toString());
  }



  getTimeline() {

    gsap.defaults({
      ease: "power4.inOut",
      duration: 0.4
    });

    const tl = gsap.timeline({
      paused: true,
      onStart: () => this.$menu.hidden = false,
      onReverseComplete: () => this.$menu.hidden = true
    });

    // Use matchMedia to check screen width
    if (window.matchMedia("(max-width: 1199px)").matches) {

      const fullHeight = this.measureHeightOfHiddenElement(this.$menu);

      // Mobile animations
      tl.fromTo(this.$menu, {
        height: 0,
        overflow: "hidden"
      }, {
        height: fullHeight,
        onComplete: () => {
          this.$menu.style.height = 'auto'; // Reset to auto after animation for responsive flexibility.
        }
      }, "a");

      tl.from(this.$menu.querySelectorAll('.nav__menu-item'), {
        duration: 0.35,
        y: "-=4",
        opacity: 0,
        stagger: 0.05
      }, "a")

    } else {

      // Desktop animations
      tl.fromTo(this.$menu, {
        y: "+=4",
        opacity: 0,
        visibility: 'hidden',
      }, {
        y: 0,
        opacity: 1,
        visibility: 'visible',
      }, "a");

      tl.from(this.$menu.querySelectorAll('.nav__menu-item'), {
        duration: 0.35,
        y: "+=4",
        opacity: 0,
        stagger: 0.05
      }, "a")

    }

    return tl;
  }



  outsideClickHandler(e) {
    // Check if the click occurred outside the dropdown and its trigger.
    if (!this.$menu.contains(e.target) && !this.$trigger.contains(e.target)) {
      if (this.active && window.matchMedia("(min-width: 768px)").matches) {
        this.toggle();
      }
    }
  }



  measureHeightOfHiddenElement(element) {
    const originalStyles = [];

    let currentElement = element;
    while (currentElement && currentElement !== document.body) {
      originalStyles.push({
        el: currentElement,
        position: currentElement.style.position,
        visibility: currentElement.style.visibility,
        display: currentElement.style.display,
        height: currentElement.style.height,
        overflow: currentElement.style.overflow
      });

      currentElement.style.position = 'absolute';
      currentElement.style.visibility = 'hidden';
      currentElement.style.display = 'block';
      currentElement.style.height = 'auto';
      currentElement.style.overflow = 'visible';

      currentElement = currentElement.parentElement;
    }

    const rect = element.getBoundingClientRect();
    const height = rect.height;

    // Restore original styles
    for (const style of originalStyles) {
      style.el.style.position = style.position;
      style.el.style.visibility = style.visibility;
      style.el.style.display = style.display;
      style.el.style.height = style.height;
      style.el.style.overflow = style.overflow;
    }

    return height;
  }


}
